import { getHttpClient, NonCustodialProviderManagementApi, SurveyApi } from '@capsicum/common';

export const ncWalletApi = getHttpClient.then(client => new NonCustodialProviderManagementApi(client));
export const surveyApi = getHttpClient.then(client => new SurveyApi(client));
